import React, { useState, useEffect } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import _isEmpty from 'lodash/isEmpty';
import AddIcon from '@material-ui/icons/Add';
import { useDispatch, useSelector } from 'react-redux';
import SideBarListStyles from '../../styles/SideBarListStyle';
import { showProgress, getSelectedPubDate, getPubDates, getDoses } from '../../redux/actions/DealershipActions';
import ShowProgress from '../ui/Backdrop';
import FloatButton from './FloatButton';
import GetPubDates from '../../apis/GetPubDates';
import Service from '../../apis/service';
import { apiEndpoints } from '../../constants/apiEndpoints';
import AddNewStory from '../dailydose/AddNewStory';
export default function SelectedListItem(props) {
  const { filterArray } = props;
  const classes = SideBarListStyles();
  const [isAddnewDailyPopupOpen, setIsAddnewDailyPopupOpen] = useState(false);
  const value = props.value === undefined ? 0 : props.value;
  const dispatch = useDispatch();
  const pubDates = useSelector((state) => state.getPubDates.pubDates)?.sort((a, b) => {
    const aDate = new Date(a.publishDate);
    const bDate = new Date(b.publishDate);
    return bDate.getTime() - aDate.getTime();
  });
  const selectedDate = useSelector((state) => state.getSelectedPubDate);
  const fetchDataList = async () => {
    const data = await GetPubDates();
    if (data[0] !== undefined) {
      dispatch(getPubDates('add', data));
      dispatch(getSelectedPubDate(data[0].publishDate));
    }
  };
  useEffect(() => {
    fetchDataList();
  }, []);
  useEffect(() => {
    if (pubDates && pubDates.length > 0 && selectedDate) {
      const ind = pubDates.findIndex((date) => date.publishDate === selectedDate);
      if (ind === -1) {
        handleListItemClick(0, 0, pubDates[0].publishDate);
      }
    }
  }, [pubDates]);

  useEffect(() => {
    handleListItemClick(0, 0, selectedDate);
  }, [selectedDate]);

  const myRefs = filterArray?.reduce((acc, val) => {
    acc[val.publishDate] = React.createRef();
    return acc;
  }, {});

  const handleListItemClick = async (event, index, date) => {
    dispatch(getSelectedPubDate(date));
    dispatch(showProgress(true));
    if (!_isEmpty(myRefs) && myRefs[date]) {
      myRefs[date]?.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }

    await Service.get(apiEndpoints.STORY_BY_DATE.replace('DATE', date), '')
      .then((response) => {
        dispatch(showProgress(false));
        dispatch(getDoses('add', response));
      })
      .catch(() => {});
  };

  const fabs = [
    {
      color: 'primary',
      className: classes.fab,
      icon: <AddIcon />,
      label: 'Add',
    },
    {
      color: 'primary',
      className: classes.fab,
      icon: <AddIcon />,
      label: 'Add',
    },
  ];

  const addNewDaily = () => {
    setIsAddnewDailyPopupOpen(true);
  };

  const closeAddNewDaily = () => {
    setIsAddnewDailyPopupOpen(false);
  };

  return (
    <div className={classes.root}>
      <List component="nav" aria-label="secondary mailbox folder">
        {filterArray?.map((data, key) => {
          const index = key;
          const dateVal = new Date(data?.publishDate?.replace(/-/g, '/'));
          const date = dateVal.getDate();
          const month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][
            dateVal.getMonth()
          ];
          const ordinal = `${date} ${month} ${dateVal.getFullYear()}`;

          return (
            <div key={index} className={selectedDate === data.publishDate ? classes.highlightItem : ''}>
              <ListItem
                id={`Item${index}`}
                key={index}
                button
                selected={selectedDate === data.publishDate}
                className={classes.listStyling}
                onClick={(event) => handleListItemClick(event, index, data.publishDate)}
                ref={myRefs[data.publishDate]}
              >
                <ListItemText
                  primary={
                    <div>
                      <p
                        className={`
                          ${selectedDate === data.publishDate ? classes.listTextSelected : classes.listTextNonSelected}
                        `}
                      >
                        {ordinal}
                      </p>
                    </div>
                  }
                  secondary={
                    <div>
                      <div
                        className={
                          selectedDate === data.publishDate
                            ? classes.listSubTextSelected
                            : classes.listSubTextNonSelected
                        }
                      ></div>
                    </div>
                  }
                />
              </ListItem>
            </div>
          );
        })}
      </List>
      <FloatButton fabs={fabs} value={value} mainTabID={2} onaddNewDaily={addNewDaily} />
      {isAddnewDailyPopupOpen && <AddNewStory open close={closeAddNewDaily} add selected="" />}
      {<ShowProgress />}
    </div>
  );
}
